import { Outlet, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { getAccount } from '@/shared/lib/wagmi/accounts/getAccount.ts'
import { MemberApi } from '@/domains/auth/api'

export function AuthorizedRoute() {
  const navigate = useNavigate()

  useEffect(() => {
    async function _() {
      const account = getAccount()
      const memberData = await MemberApi.fetchInfo()

      if (!account.isConnected || !memberData) {
        navigate('/game', { replace: true })
      }
    }

    _()
  }, [])

  return <Outlet />
}
